module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei6.svg";